<template>
	<div class="kefu" :class="tabIdx == 1?'bg-e6':''">
		<div class="relative box1">
			<img :src="windowWidth > 820?'https://qiniuimg.wurun.net/pc/kf_banner.jpg':'https://qiniuimg.wurun.net/news/kf.jpg'">
			<div class="text">
				<div class="fs45 fw mt30 cor-27">联系我们</div>
				<div class="fs22  mt30 cor-27" style="letter-spacing:2px">如有意向或疑问可咨询相关客服人员，我们将竭诚为您服务</div>
				<div class="cor-8f fs10 let-spc6">Contact Us</div>
				<!-- <p class="ico"></p> -->
			</div>
		</div>
		<div class="box2 flex align-items just-around">
			<div class="w1200 flex align-items just-center">
				<div v-for="(d,i) in tab" :key="i" class="fs16" :class="i == tabIdx?'cur fw cor-27':''" @click="subTab(i)">
					{{d.name}}</div>
			</div>
		</div>
		<div class="tabIdx0 relative" v-show="tabIdx == 0">
			<img src="@/style/img/kefu_bg.png" alt="">
			<div class="w1200 relative" v-if="tabIdx == 0">
				<div class="tit" ><img src="@/style/img/kefu_bg2.png" alt=""></div>
				<span v-if="windowWidth < 820" class="text">有别于传统的加盟模式，运用全新的联盟形式，<br> 一起携手开启事业的新人生！</span>
				<span v-if="windowWidth > 820" class="text">有别于传统的加盟模式，运用全新的联盟形式， 一起携手开启事业的新人生！</span>
				<div class="box">
					<div class="tit cor-f"><span>加盟流程</span></div>
					<div class="child">
						<div v-for="(d,i) in tab1" :key="i">
							<div>
								<img :src="d.url" alt="">
								<img src="@/style/img/fr.png" alt="" class="run">
							</div>
							<span>{{d.name}}</span>
						</div>
					</div>
					<div class="phone">
						<p>加盟热线</p>0592-5586808
					</div>
				</div>
			</div>
		</div>
		<div class="tabIdx1" v-show="tabIdx == 1">
			<div class="w1200" v-if="tabIdx == 1">
				<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/zpBg.png" class="bg">
				<div v-for="(d,i) in tab2" :key="i" class="relative">
					<div class="tit">
						<span>{{d.name}}</span>
					</div>
					<div class="cont" v-html="d.text"></div>
					<svgIcon iconClass="w" class="w"/>
				</div>
				<!-- <div class="phone" v-if="windowWidth > 820">联系电话：18159282879<span>简历投递：HR@wurun.net</span> </div>
				<div class="phone" v-if="windowWidth < 820">联系电话：18159282879<br> 简历投递：HR@wurun.net</div> -->
			</div>
		</div>
		<div v-show="tabIdx == 2">
			<div class="box3">
				<div class="tit" v-if="windowWidth > 820">
					<span class="fs42 fw relative">联系我们</span>
					<!-- <p class="fs48">CONTACT US</p> -->
				</div>
				<div class="from flex just-between w1200">
					<div class="fl">
						<div class="tit fs36 fw cor-27">厦门五润集团</div>
						<div class=" mt20">
							<div class="phones fs18">
								<div class=" mt10 h4">全国服务热线</div>
								<div class="fs30 fw cor-27 border">400-0592-568</div>
								<div class="mt14  mt10 h4">前台客服热线</div>
								<div class="">
									<p class="cor-27 fs30 mt10 fw ">0592-5585801</p>
									<p class="fs14 cor-d border">（周一至周五，早上08:30~12:00，下午13:30~18:00）</p>
								</div>
							</div>
						</div>
						<div class="em  mt20">
							<div class="phones">
								<div class="mt10 fs18 h4">企业邮箱</div>
								<div class="fs18 fw cor-27 border">wurunjituan@wurun.net</div>
							</div>
						</div>
						<div class="address flex">
							<div class="phones">
								<div class=" mt10 fs18 h4">总部地址</div>
								<div class="fs16 fw cor-27">厦门市湖里区高林中路491号天地金融港2号楼16层</div>
							</div>
						</div>
					</div>
					<div class="fr phones">
						<div class="tit fs24 fw mt10 cor-27 h4">感谢您对五润集团的关注与支持</div>
						<div class="tits fs14">为了帮助您更快的解决问题，请先参考通过联系客服热线的方式。如果以上途径仍无法解决您的疑问，请填写以下信息，以便我们及时给您反馈。</div>
						<div class="input flex align-items">
							<input type="text" placeholder="您的姓名" v-model="UserName">
							<input type="text" placeholder="您的电话" v-model="phone">
							<input type="text" placeholder="您的邮箱" v-model="email">
						</div>
						<div class="note">
							<textarea name="" placeholder="请填写您的需求或建议" v-model="note" id="" cols="30" rows="10"></textarea>
						</div>
						<div class="submit" @click="submit">提交</div>
					</div>
				</div>
			</div>
			<div class="map" >
				<div id="container"></div>
			</div>
		</div>
		<div @click="upShow" class="upShow"  v-if="msgShow">
			<msg :data="msgData"/>
		</div>
		<rightTab v-if="windowWidth > 820" />
	</div>
</template>
<script src="https://unpkg.com/axios@0.20.0/dist/axios.min.js"></script>
<script>
	require('../../style/css_w/kefu.css');
	import AMapLoader from "@amap/amap-jsapi-loader";
	import rightTab from "@/components/rightTab.vue"
	import msg from "@/components/msg.vue"
	export default {
		name: 'News',
		components: {
			rightTab,
			msg
		},
		data() {
			return {
				msgShow:false,
				windowWidth:'',
				tabIdx: 0,
				UserName: '',
				phone: '',
				email: '',
				note: '',
				map: '',
				msgData:{
					name:'',
					title:''
				},
				tab: [{
					name: '招商投资'
				}, {
					name: '招聘人才'
				}, {
					name: '联系我们'
				}],
				tab1: [{
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/jm1.png',
					name: '合作申请'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/jm2.png',
					name: '实地考察'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/jm3.png',
					name: '正式签约'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/jm4.png',
					name: '开店筹备'
				}, {
					url: 'https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/jm5.png',
					name: '正式营业'
				}],
				tab2: [{
					url: 'us3',
					name: '五润营业员',
					k: '5K-7k',
					text:'<span class="h4">主要职责：</span>主要负责顾客点餐、收银、配餐、出餐、收桌；店堂环境维护和产品品质把控。<span class="h4">发展渠道：</span>营业员—训练员—副店长—店长—店总—区域经理—营运经理（自由发挥）—营运总监（尽情绽放）—总经理（只要你敢想）。<span class="h4">基本要求：</span>1.离工作门店较近，会骑电动车最好，参考通勤时间30分钟以内；<br/>2.是否能早起；<br/>3.爱笑，眼睛会传达笑意，说话声音有活力，说话有礼貌;<br/>4.及时发现顾客的需求，愿意把顾客的满意度放在第一位；<br/>5.能够接纳和包容其他人的优缺点，也愿意配合公司的安排，乐于改变，有错误愿意正视和改变，积极帮助他人且也能让他人帮助自己。<br/>',
				}, {
					url: 'us2',
					name: '五润面点师',
					k: '6k-8k',
					text:'<span class="h4">主要职责：</span>主要负责主要负责包子、饺子、抄手、三明治、饭团等产品的包制和蒸煮。<span class="h4">发展渠道：</span>面点师—训练员—副店长—店长—店总—区域经理—营运经理（自由发挥）—营运总监（尽情绽放）—总经理（只要你敢想）。<span class="h4">基本要求：</span>1.离工作门店较近，会骑电动车最好，参考通勤时间30分钟以内；<br/>2.是否能早起；<br/>3.做事有自己的速度要求，能够灵活适应不同的节奏;<br/>4.熟悉或者善于切配，对于用电用刀有安全意识；<br/>5.意服务顾客或者伙伴，有做到过或者知道怎么做；<br/>6.能够接纳和包容其他人的优缺点，也愿意配合公司的安排，乐于改变，有错误愿意正视和改变，积极帮助他人且也能让他人帮助自己。'
				}, {
					url: 'us5',
					name: '佐籽营业员',
					k: '4k-5.5k',
					text:'<span class="h4">主要职责：</span>主要负责顾客点餐、收银、配餐、出餐、收桌；店堂环境维护和产品品质把控。<span class="h4">发展渠道：</span>营业员—训练员—副店长—店长—店总—区域经理—营运经理（自由发挥）—营运总监（尽情绽放）—总经理（只要你敢想）。<span class="h4">基本要求：</span>1.离工作门店较近，会骑电动车最好，参考通勤时间30分钟以内；<br/>2.是否能早起；<br/>3.爱笑，眼睛会传达笑意，说话声音有活力，说话有礼貌;<br/>4.及时发现顾客的需求，愿意把顾客的满意度放在第一位；<br/>5.能够接纳和包容其他人的优缺点，也愿意配合公司的安排，乐于改变，有错误愿意正视和改变，积极帮助他人且也能让他人帮助自己。',
				}, {
					url: 'us4',
					name: '佐籽西点师',
					k: '5k-8k',
					text:'<span class="h4">主要职责：</span>1.根据订单需求，按照配方，利用各种工具，负责甜品的制作，包含茶歇，布丁、蛋糕等；<br/>2.生产成本的监控、产品质量的控制、产品风格的稳定；<br/>3.创新西点款式及配方，不断研发新的产品；<br/>4.完成上级安排的其他相关工作。<br/><span class="h4">基本要求：</span>1.喜爱西点行业；<br/>2.同行业工作经验2年以上的面包饼房、甜品店、饼房经验者优先；<br/>3.独立、熟练、高效制作面包、饼干、欧式蛋糕等烘焙制作；<br/>4.为人谦和，耐心，有责任心；<br/>5.年龄在18-40岁之间，学历、专业、性别均不限；<br/>6.身体健康，无不良嗜好，需持健康证上岗。',
				}, {
					url: 'us1',
					name: '储备干部',
					k: '',
					text:'<span class="h4">应聘要求：</span>1、20-32周岁；<br/>2、本科及以上学历；<br/>3、接受应届毕业生和实习生。<br/><span class="h4">职位介绍：</span><span class="h3">完善晋升通道及工作内容：</span><br/>1.储备干部（3个月）：服务组内容学习；<br/>2.训 练 员（6个月）：培训、值班管理（人、场、物管理）等学习；<br/>3.副 经 理（6个月）：员工排班 、订存货、仓储管理、设备维护、等；<br/>4.店 经 理（6个月）：行政事务，招聘、成本管理、利润管理、财务分析等；<br/>5.店  总  经  理   ：学习品牌管理、商圈物业管理、门店整体运营等；<br/>6.晋升更高职位（区总等）；<br/><span class="h4">薪酬福利：</span><span class="h3">六险、节假日福利、生日福利、博饼、团队聚餐等；</span><br/>1.储备干部阶段：试用期综合薪资5.2K以上，转正综合薪资6.1K以上；<br/>2.训练员阶段：试用期综合薪资6.5K以上，转正综合薪资8K以上；<br/>3.副经理阶段：基本薪资+奖金；<br/>4.店经理阶段：基本薪资+奖金；<br/>5.店总经理阶段：基本薪资+奖金+分红。',
				}]
			}
		},
		created() {
			AMapLoader.load({
				key: 'b0d62ad429820e20f0818038d0d6c2b1',
				version: '2.0'
			}).then((AMap) => {
				this.map = new AMap.Map('container', {
					viewMode: "2D",
					center: [118.183463, 24.506803],
					zoom: 18,
					resizeEnable: true,
					pitch: 0
				})
				var marker = new AMap.Marker({
					position: new AMap.LngLat(118.183463, 24.506803),
					content: `
							<div class="my_marker">
								<div class="showLog">
									<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/map.png"/>
									<img src="https://qiniuimg.wurun.net/%E6%96%B0%E7%89%88/logo.png"/>
								</div>
							</div>`,
					offset: new AMap.Pixel(-10,-20)
				});
				this.map.add([marker]);
			}).catch(e => {
				console.log(e, 555);
			})
		},
		mounted() {
			if(this.$route.query.i && this.$route.query.i<3){
				this.tabIdx = this.$route.query.i?this.$route.query.i:0
			}
			this.windowWidth  = document.body.clientWidth
			document.documentElement.scrollTop = document.body.scrollTop =0;
			window.addEventListener('resize', () => this.windowWidth = window.innerWidth, false)
		},
		methods: {
			subTab(i) {
				this.tabIdx = i
			},
			upShow(){
				this.msgShow = false
			},
			submit() {
				let that = this;
				if(!that.email || !that.phone || !that.note || !that.UserName){
					that.msgShow = true;
					that.msgData = {
						name:'请填写完整信息~~',
						title:'温馨提示'
					}
					if(that.msgShow == true){
						setTimeout(() => {
							that.msgShow = false;
						}, 1500);
					}
					return;
				}
				let data = {
						email: that.email,
						phone: that.phone,
						remarks: that.note,
						username: that.UserName
				}
				that.$axios.post("http://adminapi.wurun.net/index/official_advice/add",data).then (function (res) {
					that.msgShow = true;
					that.msgData = {
						name:'感谢您的反馈，我们会尽快给您回复，请耐心等待！',
						title:'提交成功'
					}
					that.email = that.phone = that.note = that.UserName = ''
					if(that.msgShow == true){
						setTimeout(() => {
							that.msgShow = false;
						}, 1500);
					}
				})
			}
		}
	}
</script>

<style scoped>
</style>
